import { services } from "../../constants/services";
import { CreateOrUpdateBaseService } from "./createOrUpdateBase.service";


export class PostRefreshTokenService extends CreateOrUpdateBaseService<any, any> {
  // url = `${services.userCampus}/createOrUpdateUserCampus`;
  url = `${services.auth}/refresh-token`;

};

